// Mock weekly lottery data + helpers.
// Entries = number of *completed* trades the user has on record.

export const WEEKLY_PRIZE = 13500; // V-Bucks (mocked)

export const PRIZE_TIERS = [
  { rank: '1st Place', vbucks: 13500, color: '#ffd900' },
  { rank: '2nd Place', vbucks: 5000, color: '#d6d6e6' },
  { rank: '3rd Place', vbucks: 2500, color: '#cd7f32' },
];

export const RECENT_WINNERS = [
  { name: 'ShadowFox99', vbucks: 13500, week: 'Last week' },
  { name: 'NinjaSlayer42', vbucks: 5000, week: 'Last week' },
  { name: 'DustyDuck', vbucks: 2500, week: 'Last week' },
  { name: 'PixelPirate', vbucks: 13500, week: '2 weeks ago' },
  { name: 'GalaxyGremlin', vbucks: 5000, week: '2 weeks ago' },
  { name: 'StormStriker', vbucks: 13500, week: '3 weeks ago' },
];

// Returns next Sunday at 20:00 local time
export function nextDrawDate(now = new Date()) {
  const d = new Date(now);
  const day = d.getDay(); // 0 = Sun
  const daysUntilSun = day === 0 ? (d.getHours() < 20 ? 0 : 7) : 7 - day;
  d.setDate(d.getDate() + daysUntilSun);
  d.setHours(20, 0, 0, 0);
  return d;
}

export function timeLeft(target, now = new Date()) {
  const ms = Math.max(0, target.getTime() - now.getTime());
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const seconds = Math.floor((ms / 1000) % 60);
  return { ms, days, hours, minutes, seconds };
}

export function countCompleted(trades) {
  return trades.filter((t) => t.status === 'completed').length;
}

export function totalPoolEntries(trades) {
  // Add a few mocked baseline community entries so the pool feels alive
  return countCompleted(trades) + 1247;
}
